import {Map} from 'immutable';
import {has}  from 'lodash';

import {
  SETTINGS_ERROR,
  SETTINGS_REQUEST,
  GET_SETTINGS_SUCCESS,
} from '../actions/settings';

function setSettingsRequest(state) {
  return state.merge({
    _metadata: Map({
      error: false,
    }),
  });
}

const setSettingsError = (state, action) => {
  let error;
  const connectErrorMessage = 'Unable to establish connection to https://policyacumen.health/api, please check firewall and network.';

  // Settings lambda is only expected to return 500 or 404 responses
  // Anything else is likely to be caused by client or network level blocking
  if (has(action, 'error.status')) {
    switch (action.error.status) {
      case 400:
        //Bad request with json schema validation error
        error = 'Unable to process your request at this time. Please try again later.';
        break;
      case 404:
        error = 'This page currently does not exist.';
        break;
      case 500:
        error = 'Unable to process your query at this time. Please try again later.';
        break;
      default:
        error = connectErrorMessage;
    }
  } else {
    error = connectErrorMessage;
  }

  return state.merge({
    _metadata: Map({
      error,
    }),
  });
}

function setSettingsSuccess(state, action) {
  const {
    settings,
  } = action.payload;

  return state.merge({
    settings: Map(settings),
    _metadata: Map({
      error: false,
    }),
  });
}

export default function (state = Map({
  settings: Map(),
  _metadata: Map({
    error: false,
  }),
}), action) {

  switch (action.type) {
    case SETTINGS_REQUEST:
      return setSettingsRequest(state);

    case GET_SETTINGS_SUCCESS:
      return setSettingsSuccess(state, action);

    case SETTINGS_ERROR:
      return setSettingsError(state, action);

    default:
      return state;
  }
}